import { graphql } from "relay-runtime"

export const chMeasRadiologyPrescriptionFragment = graphql`
  fragment chMeasRadiologyPrescriptionFragment on ch_MeasRadiologyPrescription {
    id
    patientId
    progressNoteId
    createdAt
    createdBy
    signedAt
    signedBy
    language
    clinicalAssessment
    employer
    pregnantStatus
    question
    requestExaminations
    updatedAt
    updatedBy
    sentAt
    sentBy
    concludedAt
    concludedBy
    fileId
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
